import { PortoBiometryChannel } from '../../../../../../services/porto-biometry';

const ACTION_LABELS: Record<string, string> = {
  LINK: 'Link gerado pela Porto',
  ENVIO: 'Link enviado ao locatário',
  REENVIO: 'Link reenviado ao locatário',
  'LINK COPIADO': 'Link copiado no portal da Porto',
  'ENVIO AUTOMATICO': 'Envio automático da Porto',
  'REENVIO AUTOMATICO': 'Reenvio automático da Porto',
  ACAO_EXPIRADO: 'Link expirado'
};

const REQUESTER_LABELS: Record<string, string> = {
  CORRETOR: 'Corretora',
  SISTEMA: 'Porto Seguro',
  API: 'Integração'
};

const CHANNEL_LABELS: Record<string, string> = {
  SMS: 'SMS',
  EMAIL: 'e-mail'
};

export function getActionLabel(action: string): string {
  if (ACTION_LABELS[action]) {
    return ACTION_LABELS[action];
  }
  const text = String(action || '').toLowerCase();
  return text.charAt(0).toUpperCase() + text.slice(1);
}

export function getRequesterLabel(requester: string | null): string | null {
  if (!requester) {
    return null;
  }
  return REQUESTER_LABELS[requester] || requester;
}

export function getChannelLabel(channel: string): string {
  return CHANNEL_LABELS[channel] || channel;
}

export function onlyDigits(value: string): string {
  return String(value || '').replace(/\D/g, '');
}

export function formatPhone(value: string | null | undefined): string {
  const digits = onlyDigits(value || '').slice(0, 11);
  if (digits.length <= 2) {
    return digits ? `(${digits}` : '';
  }
  if (digits.length <= 6) {
    return `(${digits.slice(0, 2)}) ${digits.slice(2)}`;
  }
  if (digits.length <= 10) {
    return `(${digits.slice(0, 2)}) ${digits.slice(2, 6)}-${digits.slice(6)}`;
  }
  return `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7)}`;
}

export function formatRecipient(channel: string, recipient: string): string {
  return channel === 'SMS' ? formatPhone(recipient) : recipient;
}

export function isValidRecipient(channel: PortoBiometryChannel, value: string): boolean {
  if (channel === 'SMS') {
    return /^[1-9]{2}9\d{8}$/.test(onlyDigits(value));
  }
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value || '').trim());
}

export function formatDateTime(iso: string | null | undefined): string | null {
  if (!iso) {
    return null;
  }
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) {
    return null;
  }
  const day = date.toLocaleDateString('pt-BR', { timeZone: 'America/Sao_Paulo' });
  const time = date.toLocaleTimeString('pt-BR', {
    timeZone: 'America/Sao_Paulo',
    hour: '2-digit',
    minute: '2-digit'
  });
  return `${day} às ${time}`;
}

export function formatCountdown(ms: number): string {
  const totalSeconds = Math.max(Math.ceil(ms / 1000), 0);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${minutes}:${String(seconds).padStart(2, '0')}`;
}
